export const normalizeDate = (value: string | number) => {
  const timestamp =
    typeof value === 'number' || /^\d+$/.test(value) ? Number(value) : null

  if (timestamp !== null && Number.isFinite(timestamp)) {
    return new Date(timestamp < 1_000_000_000_000 ? timestamp * 1000 : timestamp)
  }

  return new Date(value)
}

export const formatDate = (dateStr: string | number) => {
  const date = normalizeDate(dateStr)
  const formatted = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Moscow',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date)
  return `${formatted}`
}
